import { CssBaseline, Theme, Typography, useMediaQuery } from "@mui/material"
import { useGetProviderNameQuery } from "generated/graphql"
import headerAdapter from "graphql/adapters/Header.adapter"
import useProviderVars from "graphql/defaultVariables/ProviderVariables"
import { FC, useEffect } from "react"
import { useTranslation } from "react-i18next"

import MainDrawer from "../MainDrawer"
import NavigationLinks from "../NavigationLinks"
import {
  DisplayNameNotificationsContainer,
  DrawerContainer,
  DrawerDesktop,
  DrawerMobile,
  HeaderContainer,
  NavigationLinkContainer,
  StyledAppBar,
  StyledIconButton,
  StyledMenuIcon,
  StyledToolbar
} from "./Header.styles"
import { IHeader } from "./Header.types"

const Header: FC<IHeader> = ({
  openDrawer = true,
  setOpenDrawer = () => {}
}) => {
  const { t } = useTranslation("global")
  const isDownMd = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"))
  const vars = useProviderVars()
  const providerAPI = useGetProviderNameQuery({
    ...vars
  })

  const handleDrawerToggle = () => setOpenDrawer(!openDrawer)

  const { providerName } = headerAdapter({ dataAPI: providerAPI.data })

  useEffect(() => {
    if (isDownMd) setOpenDrawer(false)
  }, [isDownMd, setOpenDrawer])

  return (
    <HeaderContainer>
      <CssBaseline />
      <StyledAppBar position="fixed">
        <StyledToolbar>
          <DisplayNameNotificationsContainer data-testid="NotificationsContainer">
            <StyledIconButton
              aria-label={t("component.Header.openDrawer")}
              color="primary"
              edge="start"
              onClick={handleDrawerToggle}
            >
              <StyledMenuIcon />
            </StyledIconButton>
            <Typography noWrap data-testid="providerName">
              {providerName}
            </Typography>
          </DisplayNameNotificationsContainer>
          <NavigationLinkContainer>
            <NavigationLinks direction="row" />
          </NavigationLinkContainer>
        </StyledToolbar>
      </StyledAppBar>

      <DrawerContainer aria-label="navigation" component="nav">
        <DrawerDesktop
          data-testid="DesktopNavigation"
          open={openDrawer}
          variant="persistent"
        >
          <MainDrawer />
        </DrawerDesktop>
        <DrawerMobile
          data-testid="MobileNavigation"
          ModalProps={{
            keepMounted: true
          }}
          open={openDrawer}
          variant="temporary"
          onClose={handleDrawerToggle}
        >
          <MainDrawer />
        </DrawerMobile>
      </DrawerContainer>
    </HeaderContainer>
  )
}

export default Header
